import { ChangeDetectorRef, Component, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-stream-chat',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="p-4 border rounded border-neutral-300">
      <div class="whitespace-pre-wrap" dir="auto">
        <span>{{ displayedText }}</span>
      </div>
    </div>
  `,
})
export class StreamChatComponent {
  apiUrl = input.required<string>();
  token = input.required<string>();
  payload = input.required<any>();
  cdr = inject(ChangeDetectorRef);

  displayedText = 'Response will appear here...';

  async startStream() {
    this.displayedText = '';

    const response = await fetch(`${this.apiUrl()}/workflows/run`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: this.token(),
      },
      body: JSON.stringify(this.payload()),
    });

    if (!response.body) {
      console.error('No response body');
      return;
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });
      const parts = buffer.split('\n\n');

      buffer = parts.pop() || '';

      for (const part of parts) {
        if (part.startsWith('data:')) {
          const data = part.replace('data: ', '').trim();
          if (!data || data === '[DONE]') continue;

          try {
            const parsed = JSON.parse(data);
            if (parsed.event === 'text_chunk') {
              this.typeWriter(parsed.data.text);
            }
          } catch (err) {
            console.warn('Skipping incomplete JSON:', data);
          }
        }
      }
    }
  }

  private typeWriter(text: string) {
    this.displayedText += text;
    this.cdr.detectChanges();
  }
}
